module.exports = __webpack_public_path__ + "img/mariya-georgieva.66c8b404.jpg";